<template>
    <div class="page">
        <tabs :tabs="tabs" router-tab />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import routeNames from '@enums/route-names';

export default {
    computed: {
        ...mapState('clientConfig', ['toggleLogic']),
        tabs() {
            const tabs = [
                {
                    label: this.toSentenceCase(this.$t('parkingLotTabs.pastPromotions')),
                    disabled: false,
                    // component: 'past-promotions',
                    routeNames: [routeNames.pastPromotionsView],
                    class: 'past-promotions-tab',
                    path: '/parking-lot/past-promotions',
                },
                {
                    label: this.toSentenceCase(this.$t('parkingLotTabs.parkingLot')),
                    disabled: false,
                    // component: 'parking-lot',
                    routeNames: [routeNames.parkingLotView],
                    class: 'parking-lot-tab',
                    path: '/parking-lot/parking-lot-page',
                },
                {
                    label: this.toSentenceCase(this.$t('parkingLotTabs.subCampaignAllocation')),
                    disabled: false,
                    // component: 'sub-campaign-allocation',
                    routeNames: [routeNames.subCampaignAllocationView],
                    class: 'sub-campaign-allocation-tab',
                    path: '/parking-lot/sub-campaign-allocation',
                },
            ];

            return tabs;
        },
    },
};
</script>

<style scoped lang="scss">
$past-promotions-tab: #aecadb;
$rtls-parking-lot-tab-color: #4ca183;
$rtls-sub-campaign-allocation-tab-color: #94ab28;

.page {
    height: 100%;
    padding: 2rem 1rem 4.5rem 1rem;
}

// Vuetify overrides needed for making the tabs fill the available vertical space.
:deep(.v-tabs.promo-tabs.v-theme--light) {
    height: 100%;
    display: flex;
    flex-direction: column;
}

:deep(.v-window.v-item-group.v-theme--light.v-tabs-items) {
    flex: 1 0 0;
}

:deep(.v-window__container) {
    height: 100%;
}

:deep(.v-window__container) {
    height: 100%;

    .past-promotions-grid-container {
        border-left: 0.3rem solid $past-promotions-tab;
    }

    .parkinglot-grid-container {
        border-left: 0.3rem solid $rtls-parking-lot-tab-color;
    }

    .sub-campaign-allocation-grid-container {
        border-left: 0.3rem solid $rtls-sub-campaign-allocation-tab-color;
    }
}

:deep() {
    .promo-tabs .promo-tabs__tab {
        &.parking-lot-tab {
            border-left-color: $rtls-parking-lot-tab-color;
        }

        &.sub-campaign-allocation-tab {
            border-left-color: $rtls-sub-campaign-allocation-tab-color;
        }
    }

    .ag-checkbox-center {
        display: flex;
        align-content: center;
        justify-content: center;
    }
}
</style>
